module.exports = __webpack_public_path__ + "static/media/vector3_1.d8f0249b.png";